/**
 * Returns true if @param maybeAncestor is an ancestor of @param element or undefined if unknown
 */
export function hasElementAsAncestor(element: Element, maybeAncestor: Element, maxDepth?: number): boolean | undefined {
  const root = document.getElementsByTagName('html')[0];
  return recurse(element, maybeAncestor, maxDepth || null, 0);

  // tslint:disable-next-line: no-shadowed-variable
  function recurse(element: Element, toFind: Element, maxDepth: number | null, depth: number): boolean | undefined {
    if (maxDepth != null && depth > maxDepth) {
      return false;
    }

    if (element == toFind) {
      return true;
    }

    if (element.parentElement) {
      return recurse(element.parentElement, toFind, maxDepth, depth + 1);
    }

    return element == root ? false : undefined;
  }
}

export function inViewport(element: Element): boolean {
  const boundingRect = element.getBoundingClientRect();
  return !(boundingRect.top > innerHeight || boundingRect.bottom < 0);
}

export function getPreviousSiblings(elem: Element): Element[] {
  const previousSiblings = [];
  let previousSibling = elem.previousSibling;
  while (previousSibling) {
      previousSiblings.push(elem);
      previousSibling = previousSibling.previousSibling;
  }
  return previousSiblings;
}